import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFirestoreConnect } from "react-redux-firebase";
import moment from "moment";
import config from "../../../config/common";
import Row from "./Row";
import Cell from "./Cell";
import Arrow from "./Arrow";
import Direction from "./Direction";

const WindRow = props => {
  const { spotName, time } = props;
  useFirestoreConnect([
    {
      collection: "wind",
      doc: spotName,
    },
  ]);

  const wind = useSelector(
    ({ firestore: { data } }) => data.wind && data.wind[spotName]
  );
  console.log("windData", wind && wind.windData);
  const windTime = date =>
    moment(date).add(config.timeCorrection, "hours").format("HH:mm");

  const RowContent = data => {
    console.log("data", data);

    const rowData = data.data;
    const value = (rowData.windSpeed * config.msToKnotsMulitplier).toFixed(1);
    if (windTime(rowData.dateTime) === time) {
      const direction = parseInt(Number(rowData.windDirecrtion));
      const windLabel = direction => {
        let label = undefined;
        if (direction > 45 && direction < 160) {
          label = "Levante";
        }
        if (direction < 350 && direction > 200) {
          label = "Poniente";
        }
        if (direction < 46 && direction > 349) {
          label = "North";
        }
        if (direction < 201 && direction > 160) {
          label = "South";
        }
        return label;
      };
      return (
        <Row noPadding>
          <Cell fullWidth>
            {windLabel(direction)} &nbsp;{value} knots &nbsp;&nbsp;&nbsp;
            <Arrow direction={direction} />
            <Direction>{direction}º</Direction>
          </Cell>
        </Row>
      );
    }
    return null;
  };
  return (
    <>
      {wind && wind.windData && (
        <>
          {wind &&
            wind.windData &&
            wind.windData.map(item => <RowContent data={item} />)}
        </>
      )}
    </>
  );
};

WindRow.propTypes = {
  spotName: PropTypes.string.isRequired,
};

WindRow.defaultProps = {
  children: undefined,
};

export default WindRow;
